<template>
  <div class="flex flex-row">
    <div class="w-1/4 px-2 print:hidden">
      <div class="w-full bg-white no-print shadow px-4 py-3">
        <vs-button v-if="filterSelectData" class="mt-3 w-full py-4 px-3" color="primary"
                   @click="clearFilterData">{{$t('ClearAllFilters').toUpperCase()}}
        </vs-button>
        <div class="py-2"></div>
        <!--            From TO Date Filters -->
        <label style="font-size: 12px; font-weight: bold">{{ $t('Date') }}
          <span
            @click="startDate = null;filterChanged()"
            class="span-clear cursor-pointer">{{ $t("Clear") }}</span>
        </label>
        <datepicker :placeholder="$t('Date')"
                    :disabled-dates="{from: new Date()}"
                    v-model="startDate" v-on:select="filterChanged"></datepicker>
        <div class="py-2"></div>
        <div class="w-full" v-if="$localStorage.get('irole') == 0 && users.length > 0">
          <label style="font-size: 12px; font-weight: bold">{{ $t('SelectUser') }}
            <span
              @click="selectedUser = null;filterChanged()"
              class="span-clear cursor-pointer">{{ $t("Clear") }}</span>
          </label>
          <vs-select
            autocomplete
            class="pr-4 w-full"
            v-model="selectedUser"
            v-if="users.length > 0"
            @input="onFilterChanged"
          >
            <vs-select-item key="-1" :value="-1" :text="$t('All')" />
            <template v-for="(user,index) in users">
              <vs-select-item :key="index" :value="user.user_id" :text="user.username" />
            </template>
          </vs-select>
        </div>


        <vs-button  v-if="filterSelectData" class="mt-3 w-full py-4 px-3" color="primary"
                    @click="filterChanged">{{$t('Filter').toUpperCase()}}
        </vs-button>
      </div>
    </div>
    <div class="w-3/4 print:w-full pt-16 print:pt-0" style="" v-if="reportData">
      <div class="h-screen flex w-full bg-img" v-if="reportsList && reportsList.length == 0">
        <div
          class="vx-col flex items-center justify-center flex-col sm:w-1/2 md:w-3/5 lg:w-3/4 xl:w-1/2 mx-auto text-center">
          <img src="@/assets/images/pages/svg_error.svg" :alt="$t('NoData')"
               class="mx-auto mb-4 max-w-full">
          <h1 class="sm:mx-0 mx-4 mb-12 text-3xl">{{$t('NoData')}}</h1>
        </div>
      </div>
      <div style="min-width: 280px;max-width: 280px;" id="z-report-table" class="w-full flex flex-col justify-center mx-auto print:mx-0" v-else>
        <div class="flex justify-center text-center">
          <h1 class="text-3xl font-bold border-b-2 border-black"> {{ $t('ZReport') }} </h1>
        </div>
        <div class="flex flex-col w-full justify-center mx-auto" >
          <div class="mx-auto">
            <table class="w-full my-4 top-details-table">
              <tr>
                <td>
                  <p style="font-weight: bold; padding-right: 2px;">{{ $t('PrintDate') }}</p>
                </td>
                <td>
                  <p style="font-weight: bold;">{{ reportData.z_report_created }}</p>
                </td>
              </tr>
              <tr v-if="reportData.staff_name">
                <td>
                  <p style="font-weight: bold;">{{ $t('Employee') }}</p>
                </td>
                <td>
                  <p style="font-weight: bold;">{{ reportData.staff_name }}</p>
                </td>
              </tr>
              <tr>
                <td>
                  <p style="font-weight: bold;">{{ $t('Date') }}</p>
                </td>
                <td>
                  <p style="font-weight: bold;">{{ reportData.date }}</p>
                </td>
              </tr>
            </table>
          </div>
          <div class="mx-auto" style="width: 100%;">
            <table  class="z-report-data-table" style="width: 100%;">
              <tr class="z-data-title z-data-bottom-border">
                <td>{{ $t('CardName') }}</td>
                <td>{{ $t('Number') }}</td>
                <td>{{ $t('Price') }}</td>
              </tr>
<!--              <tr class="z-data-title z-data-bottom-border">-->
<!--                <td style="visibility: hidden;">&#45;&#45;&#45;&#45;&#45;&#45;</td>-->
<!--                <td>{{ $t('Number') }}</td>-->
<!--                <td>{{ $t('Price') }}</td>-->
<!--              </tr>-->
              <template v-for="(item, index) in reportsList">
                <tr :key="index" class="z-data-content z-data-bottom-border">
                  <td>
                    <p style="font-weight: bold;">
                      {{ item.product }}<span v-if="item.value"> - {{ item.value | germanNumberFormat }}</span>
                    </p>
                  </td><td style="font-weight: bold;">{{ item.quantity }}</td>
                  <td style="font-weight: bold;">{{ item.selling_price | germanNumberFormat }}</td>
                </tr>
<!--                <tr class="z-data-content z-data-bottom-border">-->
<!--                  <td style="font-weight: bold;"></td>-->
<!--                  <td style="font-weight: bold;">{{ item.quantity }}</td>-->
<!--                  <td style="font-weight: bold;">{{ item.selling_price | germanNumberFormat }}</td>-->
<!--                </tr>-->
              </template>
              <tr class="z-data-title z-data-bottom-border">
                <td></td>
                <td>{{ $t('Total') }} : </td>
                <td>{{ reportData.z_report_total_amount | germanNumberFormat }}</td>
              </tr>
            </table>
          </div>
        </div>
        <div class="flex justify-center pt-4 no-print">
          <vs-button class="mt-3 py-4 px-3" color="primary"
                     @click="printPage">{{$t('Print').toUpperCase()}}
          </vs-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Datepicker from 'vuejs-datepicker'
import moment from 'moment'

export default {
  name: 'ZReportView',
  data() {
    return {
      reportData: null,
      reportsList: null,
      selectedUser: -1,
      filterSelectData: {},
      startDate: null,
    }
  },
  components: {
    Datepicker,
  },
  computed: {
    users() {
      return this.$store.state.user.users
    },
    activeUserInfo() {
      return this.$store.state.AppActiveUser
    },
    disabledDates() {
      if (!this.startDate) {
        return { from: new Date() }
      }
      return {
        to: this.startDate,
        from: new Date(),
      }
    },
  },
  methods: {
    clearFilterData() {
      this.filterSelectData = {}
      this.startDate = null
      this.selectedUser = -1
      this.filterChanged()
    },

    onFilterChanged() {
      this.filterChanged()
    },
    getFilters() {
      const filter = {}
      // Object.keys(this.filterSelectData).forEach((key) => {
      //   if (this.filterSelectData[key] != null) {
      //     filter[key] = this.filterSelectData[key].replace(key, '')
      //   }
      // })
      if (this.startDate) {
        filter.date = moment(this.startDate).format('yyyy-MM-DD')
      }
      if (this.selectedUser != -1) {
        filter.user_id = this.selectedUser
      }
      return filter
    },
    filterChanged() {
      this.fetchZReport()
    },
    fetchZReport() {
      const filter = this.getFilters()
      this.$vs.loading()
      return this.$store.dispatch('reports/fetchZReport', { filter })
        .then((data) => {
          this.reportData = data
          this.reportsList = this.reportData.z_report
          this.$vs.loading.close()
          this.errorFetching = false
        })
        .catch((error) => {
          this.$vs.loading.close()
          this.errorFetching = true
          this.$vs.notify({
            position: 'top-center',
            title: 'Error',
            text: error.response.data.message || error.message,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger',
          })
        })
    },

    loadUsers(isMore = false) {
      this.$store.dispatch('user/fetchSellerUsers', { isMore })
        .then((data) => {
        })
        .catch((err) => {
          this.errorFetching = true
          this.$vs.notify({
            position: 'top-center',
            title: 'Error',
            text: err.response.data.message || err.message,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger',
          })
        })
    },
    printPage() {
      const divContents = document.getElementById('z-report-table').parentElement.innerHTML
      console.log(divContents)
      const a = window.open('', '')
      a.document.write('<html>')
      a.document.write('<body >')
      a.document.write('<style> '
          // eslint-disable-next-line max-len
          + '*,::after,::before{box-sizing:border-box;border-width:0;border-style:solid;border-color:#e5e7eb}::after,::before{--tw-content:\'\'}html{line-height:1.5;-webkit-text-size-adjust:100%;-moz-tab-size:4;tab-size:4;font-family:ui-sans-serif,system-ui,-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,"Helvetica Neue",Arial,"Noto Sans",sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol","Noto Color Emoji"}body{margin:0;line-height:inherit}hr{height:0;color:inherit;border-top-width:1px}abbr:where([title]){-webkit-text-decoration:underline dotted;text-decoration:underline dotted}h1,h2,h3,h4,h5,h6{font-size:inherit;font-weight:inherit}a{color:inherit;text-decoration:inherit}b,strong{font-weight:bolder}code,kbd,pre,samp{font-family:ui-monospace,SFMono-Regular,Menlo,Monaco,Consolas,"Liberation Mono","Courier New",monospace;font-size:1em}small{font-size:80%}sub,sup{font-size:75%;line-height:0;position:relative;vertical-align:baseline}sub{bottom:-.25em}sup{top:-.5em}table{text-indent:0;border-color:inherit;border-collapse:collapse}button,input,optgroup,select,textarea{font-family:inherit;font-size:100%;line-height:inherit;color:inherit;margin:0;padding:0}button,select{text-transform:none}[type=button],[type=reset],[type=submit],button{-webkit-appearance:button;background-color:transparent;background-image:none}:-moz-focusring{outline:auto}:-moz-ui-invalid{box-shadow:none}progress{vertical-align:baseline}::-webkit-inner-spin-button,::-webkit-outer-spin-button{height:auto}[type=search]{-webkit-appearance:textfield;outline-offset:-2px}::-webkit-search-decoration{-webkit-appearance:none}::-webkit-file-upload-button{-webkit-appearance:button;font:inherit}summary{display:list-item}blockquote,dd,dl,figure,h1,h2,h3,h4,h5,h6,hr,p,pre{margin:0}fieldset{margin:0;padding:0}legend{padding:0}menu,ol,ul{list-style:none;margin:0;padding:0}textarea{resize:vertical}input::placeholder,textarea::placeholder{opacity:1;color:#9ca3af}[role=button],button{cursor:pointer}:disabled{cursor:default}audio,canvas,embed,iframe,img,object,svg,video{display:block;vertical-align:middle}img,video{max-width:100%;height:auto}[hidden]{display:none}*,::after,::before{--tw-translate-x:0;--tw-translate-y:0;--tw-rotate:0;--tw-skew-x:0;--tw-skew-y:0;--tw-scale-x:1;--tw-scale-y:1;--tw-pan-x: ;--tw-pan-y: ;--tw-pinch-zoom: ;--tw-scroll-snap-strictness:proximity;--tw-ordinal: ;--tw-slashed-zero: ;--tw-numeric-figure: ;--tw-numeric-spacing: ;--tw-numeric-fraction: ;--tw-ring-inset: ;--tw-ring-offset-width:0px;--tw-ring-offset-color:#fff;--tw-ring-color:rgb(59 130 246 / 0.5);--tw-ring-offset-shadow:0 0 #0000;--tw-ring-shadow:0 0 #0000;--tw-shadow:0 0 #0000;--tw-shadow-colored:0 0 #0000;--tw-blur: ;--tw-brightness: ;--tw-contrast: ;--tw-grayscale: ;--tw-hue-rotate: ;--tw-invert: ;--tw-saturate: ;--tw-sepia: ;--tw-drop-shadow: ;--tw-backdrop-blur: ;--tw-backdrop-brightness: ;--tw-backdrop-contrast: ;--tw-backdrop-grayscale: ;--tw-backdrop-hue-rotate: ;--tw-backdrop-invert: ;--tw-backdrop-opacity: ;--tw-backdrop-saturate: ;--tw-backdrop-sepia: }.mx-auto{margin-left:auto;margin-right:auto}.my-4{margin-top:1rem;margin-bottom:1rem}.mt-3{margin-top:.75rem}.flex{display:flex}.table{display:table}.w-full{width:100%}.w-96{width:24rem}.transform{transform:translate(var(--tw-translate-x),var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))}.flex-col{flex-direction:column}.justify-center{justify-content:center}.border-b-2{border-bottom-width:2px}.border-black{--tw-border-opacity:1;border-color:rgb(0 0 0 / var(--tw-border-opacity))}.py-4{padding-top:1rem;padding-bottom:1rem}.px-3{padding-left:.75rem;padding-right:.75rem}.pt-4{padding-top:1rem}.text-center{text-align:center}.text-3xl{font-size:1.875rem;line-height:2.25rem}.font-bold{font-weight:700}.transition{transition-property:color,background-color,border-color,fill,stroke,opacity,box-shadow,transform,filter,-webkit-text-decoration-color,-webkit-backdrop-filter;transition-property:color,background-color,border-color,text-decoration-color,fill,stroke,opacity,box-shadow,transform,filter,backdrop-filter;transition-property:color,background-color,border-color,text-decoration-color,fill,stroke,opacity,box-shadow,transform,filter,backdrop-filter,-webkit-text-decoration-color,-webkit-backdrop-filter;transition-timing-function:cubic-bezier(0.4,0,0.2,1);transition-duration:150ms}.z-report-data-table{width:100%;border-width:2px;--tw-border-opacity:1;border-color:rgb(0 0 0 / var(--tw-border-opacity));font-weight:700}.z-report-data-table td{padding-left:.25rem;padding-right:.25rem;padding-top:.25rem;padding-bottom:.25rem}.z-report-data-table .z-data-title{font-weight:700}.z-report-data-table .z-data-bottom-border{width:100%;border-bottom-width:2px;--tw-border-opacity:1;border-color:rgb(0 0 0 / var(--tw-border-opacity))} table {font-size: 12px !important;}  .no-print {display: none;} @media print{.print\\:mx-0{margin-left:0;margin-right:0} #z-report-table {font-size: 10px !important; min-width: 196px !important; max-width: 196px !important;}}'
          + '</style>')
      a.document.write(divContents)
      a.document.write('</body></html>')

      setTimeout(() => {
        a.print()
        // a.close()
      }, 600)
      // if(this.reportData.filter.start_date) {
      //   let startDate = this.reportData.filter.start_date.replace("-", "")
      //   if (this.reportData.staff_name) {
      //     document.title = `z-report_${this.reportData.staff_name}_${startDate}`;
      //   } else {
      //     document.title = `z-report_${startDate}`;
      //   }
      // } else {
      //   if (this.reportData.staff_name) {
      //     document.title = `z-report_${this.reportData.staff_name}`;
      //   } else {
      //     document.title = `z-report`;
      //   }
      // }
      // window.print();
    },
  },
  mounted() {
    this.startDate = new Date()
    if (localStorage.getItem('irole') == 0) this.loadUsers()
    this.fetchZReport()
  },
}
</script>

<style scoped lang="scss">
.top-details-table {
  td {
    padding: 4px 0px;
  }
}
.z-report-data-table {
  @apply border-2 border-black w-full;

  td {
    @apply px-1 py-1;
  }
  .z-data-title {
    @apply font-bold;
  }
  .z-data-bottom-border {
    @apply border-b-2 border-black w-full;
  }
}
</style>
